﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import SelfServiceLoginPage from "./Component";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export default SelfServiceLoginPage;
export * from "./Styles";
export * from "./Component";
